module.exports = __webpack_public_path__ + "static/img/h5.e424671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour2/h5.jpg
// module id = OvZa
// module chunks = 0